// extracted by mini-css-extract-plugin
export default {"container":"RrvTWkGW1HTsEhzfS5v3-NamifestiPage-module-container"};